import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "../../lib/site";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <>
      <header
        data-testid="site-header"
        className={`fixed top-0 inset-x-0 z-50 transition-[background-color,padding,border-color] duration-500 border-b ${open ? "bg-transparent py-5 border-transparent" : scrolled ? "bg-cream/80 backdrop-blur-xl py-3 border-stone" : "bg-transparent py-5 border-transparent"}`}
      >
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo">{open ? <img src="/img/logo-cream.png" alt="Annette" className="h-11 sm:h-12 w-auto" /> : <Logo />}</Link>
          <nav className="hidden lg:flex items-center gap-9">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end data-testid={`nav-link-${n.id}`} className={({ isActive }) => `nav-link text-sm tracking-wide ${isActive ? "text-cypress is-active" : "text-ink/75 hover:text-cypress"}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <Link to="/contatti#consulenza" data-testid="nav-cta-consulenza" className="hidden lg:inline-flex items-center gap-2 rounded-full bg-cypress text-cream px-5 py-2.5 text-sm hover:bg-terra transition-colors duration-300">
            Consulenza wedding <ArrowUpRight className="w-4 h-4" />
          </Link>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen((o) => !o)} className={`lg:hidden w-11 h-11 rounded-full border flex items-center justify-center transition-colors ${open ? "border-cream/40 text-cream" : "border-cypress/30 text-cypress"}`} aria-label="Menu">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </header>
      {open && (
        <motion.div initial={{ clipPath: "inset(0 0 100% 0)" }} animate={{ clipPath: "inset(0 0 0% 0)" }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} data-testid="mobile-menu" className="fixed inset-0 z-40 bg-cypress text-cream pt-28 px-6 lg:hidden">
          <nav className="flex flex-col gap-3">
            {NAV.map((n, i) => (
              <motion.div key={n.to} initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 + i * 0.06, duration: 0.6 }}>
                <Link to={n.to} data-testid={`mobile-nav-link-${n.id}`} className="font-serif text-5xl leading-tight block">{n.label}</Link>
              </motion.div>
            ))}
          </nav>
          <Link to="/contatti#consulenza" data-testid="mobile-nav-cta" className="mt-10 inline-flex items-center gap-2 rounded-full bg-cream text-cypress px-6 py-3">Consulenza wedding <ArrowUpRight className="w-4 h-4" /></Link>
        </motion.div>
      )}
    </>
  );
};
